import { render, staticRenderFns } from "./compinfo.vue?vue&type=template&id=5a49771d&scoped=true&"
import script from "./compinfo.vue?vue&type=script&lang=js&"
export * from "./compinfo.vue?vue&type=script&lang=js&"
import style0 from "./compinfo.vue?vue&type=style&index=0&id=5a49771d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49771d",
  null
  
)

export default component.exports